/**
 * Sportconnect — Cart page interactions
 * Snazzy Digital Agency
 *
 * Met à jour les quantités via les boutons +/- en synchronisant le champ
 * input. Le submit du form reste géré nativement par Shopify (POST cart).
 */

document.querySelectorAll('.cart-line').forEach((line) => {
  const input = line.querySelector('input[type="number"]');
  const inc = line.querySelector('[data-qty-increment]');
  const dec = line.querySelector('[data-qty-decrement]');
  if (!input) return;

  inc?.addEventListener('click', () => {
    input.value = parseInt(input.value, 10) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  dec?.addEventListener('click', () => {
    input.value = Math.max(0, parseInt(input.value, 10) - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
